import clsx from 'clsx';
import React from 'react';

import styled from '@emotion/styled';

interface StatsRootProps {
  children: React.ReactNode;
}

const StatsRoot = ({ children }: StatsRootProps) => {
  return <StatsRootStyle>{children}</StatsRootStyle>;
};

interface StatsHeaderProps {
  children: React.ReactNode;
}

const StatsHeader = ({ children }: StatsHeaderProps) => {
  return <StatsHeaderStyle>{children}</StatsHeaderStyle>;
};

interface StatsValueProps {
  children: React.ReactNode;
}

const StatsValue = ({ children }: StatsValueProps) => {
  return <StatsValueStyle>{children}</StatsValueStyle>;
};

interface DynamicStatsValueProps {
  children: any;
  trend: number;
}

const DynamicStatsValue = ({ children, trend }: DynamicStatsValueProps) => {
  return (
    <DynamicStatsValueStyle
      className={clsx(trend >= 0 ? 'positive' : 'negative')}
    >
      {children}
    </DynamicStatsValueStyle>
  );
};

interface DynamicStatsFooterProps {
  children: any;
  trend: number;
}

const DynamicStatsFooter = ({ children, trend }: DynamicStatsFooterProps) => {
  return (
    <DynamicStatsFooterStyle
      className={clsx(trend >= 0 ? 'positive' : 'negative')}
    >
      {children}
    </DynamicStatsFooterStyle>
  );
};

interface PlainFooterProps {
  children: React.ReactNode;
}

const PlainFooter = ({ children }: PlainFooterProps) => {
  return <PlainFooterStyled>{children}</PlainFooterStyled>;
};

const StatsCard = {
  Root: StatsRoot,
  Header: StatsHeader,
  Value: StatsValue,
  DynamicValue: DynamicStatsValue,
  DynamicFooter: DynamicStatsFooter,
  PlainFooter: PlainFooter,
};

export default StatsCard;

const StatsRootStyle = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  border-radius: 8px;
  padding: 24px;
  gap: 18px;
  background-color: white;
`;

const StatsHeaderStyle = styled.div`
  font-size: 12px;
  line-height: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.neutralGray};
`;

const StatsValueStyle = styled.div`
  font-size: 38px;
  line-height: 38px;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.logirateBlack};
`;

const DynamicStatsValueStyle = styled(StatsValueStyle)`
  display: grid;
  grid-template-columns: 24px auto;
  align-items: center;
  gap: 16px;

  &.positive {
    color: #22b231;
  }
  &.negative {
    color: #ff0500;
  }
`;

const PlainFooterStyled = styled.div`
  color: ${({ theme }) => theme.palette.mediumGrayText};
  font-size: 12px;
  line-height: 12px;
  font-weight: 400;
`;

const DynamicStatsFooterStyle = styled(PlainFooterStyled)`
  &.positive {
    color: #2e7d32;
  }
  &.negative {
    color: #ff0500;
  }
`;
